import { createNewBit } from '@/src/actions/bits';
import { useBoolean } from '@/src/hooks/use-boolean';
import { IUIProfile } from '@/src/types/IUIProfile';
import { Button } from '@workspace/ui/components/button';
import { redirect } from 'next/navigation';
import { Icon } from '../ui';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@workspace/ui/components/dropdown-menu';
import { cn } from '@workspace/ui/lib/utils';
import { AddTilesToolbar } from './AddTilesToolbar';
import { TooltipComponent } from './TooltipComponent';
import { ERole } from 'types/src/types';

type Props = {
  profile?: IUIProfile;
};

export const FooterToolbar = ({ profile }: Props) => {
  const isOpen = useBoolean(false);
  const isLoadBit = useBoolean(false);
  const handleCreateNewBit = async () => {
    isLoadBit.onTrue();
    const { data } = await createNewBit();
    if (!data) {
      console.error('Failed to create new bit');
      return;
    }
    redirect(`/${profile?.uniqueLink}/bits/draft/${data.id}`);
  };

  return (
    <>
      <div className="p-2 bg-white rounded-lg custom-shadow flex items-center md:gap-2 justify-between w-fit mb-3 md:mb-0">
        <DropdownMenu
          modal={false}
          onOpenChange={(open) => isOpen.setValue(open)}
        >
          <DropdownMenuTrigger asChild>
            <Button size="sm" className="px-3 py-2">
              Add new
              <Icon
                name="chevron-left"
                className={cn(
                  'size-3 text-black transition-transform duration-100',
                  isOpen.value ? '-rotate-270' : '-rotate-90'
                )}
              />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="center"
            className="p-2 gap-1 font-normal text-black/40 text-base"
          >
            <TooltipComponent
              text="Share a story with rich-text."
              className="bg-white max-w-44 text-black/40"
              side="right"
            >
              <DropdownMenuItem
                className="flex items-center gap-2 py-1 px-2 cursor-pointer"
                onClick={handleCreateNewBit}
              >
                <Icon name="story-bit" className="size-3.5" />
                Story Bit
              </DropdownMenuItem>
            </TooltipComponent>
            {profile?.role === ERole.GAME_DEVELOPER && (
              <TooltipComponent
                text="Build a page for your Project."
                className="bg-white max-w-44 text-black/40"
                side="right"
              >
                <DropdownMenuItem
                  className="flex items-center gap-2 py-1 px-2 cursor-pointer"
                  onClick={() => redirect(`/project/create-new`)}
                >
                  <Icon name="project" className="size-3.5" />
                  Project
                </DropdownMenuItem>
              </TooltipComponent>
            )}
            {/* <TooltipComponent
            text="Build a visual layout with images, notes, and more."
            className="bg-white max-w-44 text-black/40"
            side="right"
          >
            <DropdownMenuItem
              disabled
              className="flex items-center gap-2 py-1 px-2 cursor-pointer"
              // onClick={handleCreateNewBuiltBit}
            >
              <Icon name="built-bit" className="size-3.5" />
              Built Bit
            </DropdownMenuItem>
          </TooltipComponent> */}
          </DropdownMenuContent>
        </DropdownMenu>

        <div className="w-0.5 mx-3 h-8 bg-[#1E1E1E0D]"></div>
        <AddTilesToolbar />
      </div>
    </>
  );
};
